import { lazy, Suspense } from "react";
import { matchPath } from "react-router";
import RoutePaths from "./route-paths";
import React from "react";
export const DEFAULT_ROUTE = RoutePaths.Home;
const PointScaling = lazy(() => import("../pages/PointScaling"));
const PSWorkspace = lazy(() => import("../pages/PS-Workspace"));
const RecipeScaling = lazy(() => import("../pages/RecipeScaling"));
const Home = lazy(() => import("../pages/Home"));
const AdminPanel = lazy(() => import("../pages/AdminPanel"));
const HelpCenter = lazy(() => import("../pages/HelpCenter"));
const RSWorkspace = lazy(() => import("../pages/RS-Workspace"));
const CellModel = lazy(() => import("../pages/CellModel"));
const Recipe = lazy(() => import("../pages/Recipe"));
const ProcessDataUpload = lazy(() => import("../pages/ProcessDataUpload"));
const Import = lazy(() => import("../pages/Import"));
export function withSuspense(Component) {
    return (React.createElement(Suspense, { fallback: React.createElement("div", null, "Loading...") },
        React.createElement(Component, null)));
}
export const routes = [
    {
        path: RoutePaths.PointScalingWorkspaces,
        element: withSuspense(PointScaling),
    },
    {
        path: RoutePaths.PointScalingWorkspace,
        element: withSuspense(PSWorkspace),
    },
    {
        path: RoutePaths.RecipeScaling,
        element: withSuspense(RecipeScaling),
    },
    {
        path: RoutePaths.RecipeScalingWorkspaces,
        element: withSuspense(RSWorkspace),
    },
    {
        path: RoutePaths.Home,
        element: withSuspense(Home),
    },
    {
        path: RoutePaths.AdminPanel,
        element: withSuspense(AdminPanel),
    },
    {
        path: RoutePaths.Help,
        element: withSuspense(HelpCenter),
    },
];
export const recipeScalingEditRoutes = [
    {
        path: RoutePaths.EditRecipeScalingWorkspace,
        element: withSuspense(RSWorkspace),
    },
    {
        path: RoutePaths.EditCellModel,
        element: withSuspense(CellModel),
    },
    {
        path: RoutePaths.EditRecipe,
        element: withSuspense(Recipe),
    },
    {
        path: `${RoutePaths.ProcessDataUpload}/*`,
        element: withSuspense(ProcessDataUpload),
    },
    {
        path: RoutePaths.ImportRecipeScalingWorkspace,
        element: withSuspense(Import),
    },
    {
        path: RoutePaths.ImportCellModel,
        element: withSuspense(Import),
    },
];
export const recipeScalingInternalRoutes = [
    ...recipeScalingEditRoutes,
    {
        path: RoutePaths.RecipeScalingWorkspace,
        element: withSuspense(RSWorkspace),
    },
    {
        path: RoutePaths.CellModel,
        element: withSuspense(CellModel),
    },
    {
        path: RoutePaths.Recipe,
        element: withSuspense(Recipe),
    },
];
export const isRegisteredRoute = (path) => {
    return routes.some((route) => matchPath({ path: route.path, end: false }, path));
};
export const isRsInternalEntityPage = (pathname) => !!pathname &&
    [
        RoutePaths.CellModel,
        RoutePaths.EditCellModel,
        RoutePaths.Recipe,
        RoutePaths.EditRecipe,
        RoutePaths.RecipeScalingWorkspace,
        RoutePaths.EditRecipeScalingWorkspace,
    ].some((path) => matchPath({ path, end: false }, pathname));
export const isProcessDataUploadPage = (pathname) => [RoutePaths.ProcessDataUpload, RoutePaths.ProcessDataObjectForImport].some((path) => matchPath({ path, end: false }, pathname));
export const isPsWorkspace = (pathname) => matchPath({ path: RoutePaths.PointScalingWorkspace, end: false }, pathname) !== null;
